module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-word-a2c3a6e8.svg";